<template>
  <div class="fixed right-5 z-50 flex flex-col" :class="{ 'bottom-20 md:bottom-5': isProductPage, 'bottom-5': !isProductPage }">
    <MirosButton class="mb-2" />
    <AsklyButton />
  </div>
</template>

<script setup lang="ts">
import MirosButton from '~/components/miros/MirosButton.vue'
import AsklyButton from '~/components/corner-buttons/AsklyButton.vue'

const router = useRouter()
const isProductPage = ref(false)
isProductPage.value = router.currentRoute.value.path.startsWith('/p/')

watch(
  () => router.currentRoute.value,
  () => {
    isProductPage.value = router.currentRoute.value.path.startsWith('/p/')
  }
)
</script>
